import { notification } from 'antd';
import moment from 'moment';
import { config, IJsonRpcResponse } from "../api";

interface ICreditResponse extends IJsonRpcResponse {
    result: {
        credits: ICredit[];
    }
}

interface ICreditSaveResponse extends IJsonRpcResponse {
    error: {
      message: string,
    };
    result: ICredit;
}

export interface ICredit {
    id: string;
    creditAmount: string;
    creditBalance: string;
    spread: number;
    type: number;
    childCompanyProfileID: number|null;
    note: string;
    createTimestamp: string;
}

export const getCredits = async (companyID: number, authToken: string) => {
    const res = await fetch(`${config.url}/getCredits/${companyID}`, {
        headers: {
            'Authorization': 'Bearer ' + authToken,
            'Content-Type': 'application/json'
        },
        method: 'get',
        mode: 'cors'
    });

    const body: ICreditResponse = await res.json();

    for (const credit of body.result.credits) {
        credit.createTimestamp = moment(credit.createTimestamp).format('ddd, MMMM D, YYYY');
    }
    return body.result.credits;
};

export const saveCredit = async (
    id: string,
    credit: ICredit,
    authToken: string,
    companyID: number
) => {
  const params = {
      companyProfileID: companyID,
      ...credit,
      id,
  };
  try {
    const res = await fetch(`${config.url}/payments/applyCredit`, {
      body: JSON.stringify(params),
      headers: {
        'Authorization': 'Bearer ' + authToken,
        'Content-Type': 'application/json'
      },
      method: 'post',
      mode: 'cors'
    });
    const body: ICreditSaveResponse = await res.json();

    if (body.error) {
      notification.error({description: body.error.message, message: 'Error'});
      return false;
    }

    const updatedCredit: ICredit = body.result;
    updatedCredit.createTimestamp = moment(credit.createTimestamp).format('ddd, MMMM D, YYYY');
    return updatedCredit;
  } catch (error) {
    // tslint:disable-next-line
    console.log(error);
    notification.error({description: 'There was a problem saving this credit', message: 'Error'});
    return false;
  }
};
